import { create } from "zustand";
import type { SearchFilters, SortOption } from "@/types";

interface SearchState {
  query: string;
  filters: SearchFilters;
  setQuery: (query: string) => void;
  setFilters: (filters: Partial<SearchFilters>) => void;
  resetFilters: () => void;
}

const defaultFilters: SearchFilters = {
  sortBy: "relevance",
};

export const useSearchStore = create<SearchState>((set) => ({
  query: "",
  filters: defaultFilters,

  setQuery: (query) => set({ query }),

  setFilters: (partial) =>
    set((state) => ({ filters: { ...state.filters, ...partial } })),

  resetFilters: () => set({ filters: defaultFilters }),
}));
